import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment, MenuItem, Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';

const API_URL = '/api/transportistas';
const emptyForm = { ruc: '', razon_social: '', direccion: '', tipo_transporte: 'Publico', numero_registro_mtc: '', estado: 1 };

const Transportistas = () => {
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [editRuc, setEditRuc] = useState(null);

  const fetch = async () => {
    const res = await axios.get(API_URL);
    setRows(res.data);
  };
  useEffect(() => { fetch(); }, []);

  const handleOpen = (row = null) => {
    if (row) { setEditRuc(row.ruc); setForm({ ruc: row.ruc, razon_social: row.razon_social, direccion: row.direccion || '', tipo_transporte: row.tipo_transporte || 'Publico', numero_registro_mtc: row.numero_registro_mtc || '', estado: row.estado }); }
    else { setEditRuc(null); setForm(emptyForm); }
    setOpen(true);
  };
  const handleClose = () => { setOpen(false); setEditRuc(null); setForm(emptyForm); };

  const handleSave = async () => {
    if (!form.ruc.trim() || form.ruc.length !== 11) { alert('RUC debe tener 11 dígitos'); return; }
    if (!form.razon_social.trim()) { alert('Razón Social es obligatoria'); return; }
    try {
      if (editRuc) await axios.put(`${API_URL}/${editRuc}`, form);
      else await axios.post(API_URL, form);
      fetch();
      handleClose();
    } catch (err) { alert(err.response?.data?.error || 'Error al guardar'); }
  };

  const toggleEstado = async (row) => {
    try {
      await axios.put(`${API_URL}/${row.ruc}`, { ...row, estado: row.estado ? 0 : 1 });
      fetch();
    } catch { alert('Error al cambiar estado'); }
  };

  const filtered = rows.filter(r =>
    `${r.ruc} ${r.razon_social} ${r.numero_registro_mtc || ''}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1400 }}>
        <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold', color: '#222' }}>Transportistas</Typography>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField placeholder="Buscar RUC o razón social..." value={search} onChange={e => setSearch(e.target.value)} size="small"
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }} sx={{ flex: 1 }} />
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()}>Nuevo Transportista</Button>
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: '#1976d2' }}>
                {['RUC', 'Razón Social', 'Dirección', 'Tipo', 'Nro. Reg. MTC', 'Estado', 'Acciones'].map(h => (
                  <TableCell key={h} sx={{ color: '#fff', fontWeight: 'bold' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map(r => (
                <TableRow key={r.ruc} hover>
                  <TableCell>{r.ruc}</TableCell>
                  <TableCell>{r.razon_social}</TableCell>
                  <TableCell sx={{ maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.direccion || '-'}</TableCell>
                  <TableCell><Chip label={r.tipo_transporte} size="small" variant="outlined" /></TableCell>
                  <TableCell>{r.numero_registro_mtc || '-'}</TableCell>
                  <TableCell>
                    <Chip label={r.estado ? 'Activo' : 'Inactivo'} color={r.estado ? 'success' : 'default'} size="small"
                      onClick={() => toggleEstado(r)} sx={{ cursor: 'pointer' }} />
                  </TableCell>
                  <TableCell>
                    <IconButton color="primary" size="small" onClick={() => handleOpen(r)}><EditIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {filtered.length === 0 && <TableRow><TableCell colSpan={7} align="center">Sin registros</TableCell></TableRow>}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
          <DialogTitle><Typography variant="h6" fontWeight="bold">{editRuc ? 'Editar Transportista' : 'Nuevo Transportista'}</Typography></DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField label="RUC" value={form.ruc} onChange={e => setForm(f => ({ ...f, ruc: e.target.value.replace(/\D/g, '').slice(0, 11) }))}
                fullWidth required disabled={!!editRuc} helperText="11 dígitos" />
              <TextField label="Razón Social" value={form.razon_social} onChange={e => setForm(f => ({ ...f, razon_social: e.target.value.toUpperCase() }))} fullWidth required />
              <TextField label="Dirección" value={form.direccion} onChange={e => setForm(f => ({ ...f, direccion: e.target.value }))} fullWidth />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField select label="Tipo de transporte" value={form.tipo_transporte} onChange={e => setForm(f => ({ ...f, tipo_transporte: e.target.value }))} sx={{ minWidth: '12em' }}>
                  <MenuItem value="Publico">Público</MenuItem>
                  <MenuItem value="Privado">Privado</MenuItem>
                </TextField>
                <TextField label="Nro. Reg. MTC" value={form.numero_registro_mtc} onChange={e => setForm(f => ({ ...f, numero_registro_mtc: e.target.value }))} fullWidth />
              </Box>
              {editRuc && (
                <TextField select label="Estado" value={form.estado} onChange={e => setForm(f => ({ ...f, estado: Number(e.target.value) }))}>
                  <MenuItem value={1}>Activo</MenuItem>
                  <MenuItem value={0}>Inactivo</MenuItem>
                </TextField>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
            <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />}>Guardar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Transportistas;
